module.exports = __webpack_public_path__ + "static/media/card-machine.831e3075.svg";